import { usePersistentIds } from 'src/hooks/use-persistent-ids'

export const useChatStorageIds = () => {
  const { browserId, sessionId } = usePersistentIds()

  const chatLocalStorageId = `${browserId}-chat`
  const chatSessionStorageId = `${sessionId}-chat`

  return { chatLocalStorageId, chatSessionStorageId }
}
